// extracted by mini-css-extract-plugin
export var dataCell = "_ol-2";
export var dataRow = "_ol-0";
export var headerRow = "_ol-1";